import { render, staticRenderFns } from "./iconSvgDocx.vue?vue&type=template&id=96b0dffc&scoped=true&"
import script from "./iconSvgDocx.vue?vue&type=script&lang=js&"
export * from "./iconSvgDocx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b0dffc",
  null
  
)

export default component.exports